export default {
  version: '2.4.3'
}